import React from 'react';
import { Link } from 'react-router-dom';
import icon01 from '../../assets/img/icon/fe-icon01.png';
import icon02 from '../../assets/img/icon/fe-icon02.png';
import icon03 from '../../assets/img/icon/fe-icon03.png';
import icon04 from '../../assets/img/icon/fe-icon04.png';

const servicesData = [
    {
        icon: icon01,
        title: 'Backup & Recovery',
        description: 'Edit your work and preview the changes on the screen live with page builder.',
        link: '/services-details',
    },
    {
        icon: icon02,
        title: 'AI & Automation',
        description: 'Edit your work and preview the changes on the screen live with page builder.',
        link: '/services-details',
    },
    {
        icon: icon03,
        title: 'Product Design',
        description: 'Edit your work and preview the changes on the screen live with page builder.',
        link: '/services-details',
    },
    {
        icon: icon04,
        title: 'VoIP Solutions',
        description: 'Edit your work and preview the changes on the screen live with page builder.',
        link: '/services-details',
    },
];

function Homeservices() {
    return (
        <>
            <section id="service-details2" className="service-details2 pt-120 pb-120 p-relative" style={{ backgroundColor: '#000' }} >
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="section-title center-align mb-80 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>services</h5>
                                <h2>Incredible solutions</h2>
                            </div>
                        </div>
                         {servicesData.map((service, index) => (
                            <div key={index} className="col-lg-3 col-md-6">
                                <div className="services-02-item mb-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                    <div className="services-02-thumb">
                                        <img src={service.icon} alt="img" />
                                    </div>
                                    <div className="services-02-content">
                                        <h3><Link to={service.link}>{service.title}</Link></h3>
                                        <p>{service.description}</p>
                                        <Link to={service.link}>
                                            <i className="fas fa-angle-right" /> Read More
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <Link to="/contact" className="btn ss-btn mt-50" data-animation="fadeInUp" data-delay=".4s">
                                <i className="fas fa-angle-right" /> more service
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default Homeservices;
